import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Button,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Typography,
  Divider,
  Box,
} from "@mui/material";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import GmailIcon from "@mui/icons-material/Email"; // you can replace with custom Gmail SVG if needed
import CloseIcon from "@mui/icons-material/Close";
import OutboxIcon from "@mui/icons-material/Outbox";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { enqueueSnackbar } from "notistack";
import { Icon } from "@iconify/react/dist/iconify.js";

const emailOptions = [
  {
    name: "Gmail",
    // color: "#EA4335",
    color: "var(--portal-text-color)",
    icon: <Icon icon="logos:google-gmail" width="31.84" height="24" />,
    url: (email, subject, body) =>
      `https://mail.google.com/mail/?view=cm&fs=1&to=${email}${
        subject ? `&su=${subject}` : ""
      }${body ? `&body=${body}` : ""}`,
  },
  {
    name: "Outlook.com",
    color: "var(--portal-text-color)",
    // color: "#0078D4",
    icon: <Icon icon="vscode-icons:file-type-outlook" width="24" height="24" />,
    url: (email, subject, body) =>
      `https://outlook.live.com/mail/deeplink/compose?to=${email}${
        subject ? `&subject=${subject}` : ""
      }${body ? `&body=${body}` : ""}`,
  },
  {
    name: "Yahoo Mail",
    color: "var(--portal-text-color)",
    // color: "#720E9E",
    icon: (
      <Icon
        icon="fa7-brands:yahoo"
        width="24"
        height="24"
        style={{ color: "#5f01d1" }}
      />
    ),
    url: (email, subject, body) =>
      `https://compose.mail.yahoo.com/?to=${email}${
        subject ? `&subject=${subject}` : ""
      }${body ? `&body=${body}` : ""}`,
  },
  // {
  //   name: "Mail App (Default)",
  //   color: "var(--portal-text-color)",
  //   icon: <MailOutlineIcon sx={{ color: "var(--portal-text-color)" }} />,
  //   url: (email, subject, body) =>
  //     `mailto:${email}?subject=${subject}&body=${body}`,
  // },
];

const MailFallbackModal = ({ open, handleClose, emailData }) => {
  const handleOpenMail = (option) => {
    const link = option.url(emailData);
    window.open(link, "_blank");
    handleClose();
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(emailData);
    enqueueSnackbar("Email Copied", { variant: "success" });
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: 3,
          paddingX: 1,
          paddingBottom: 1,
        },
      }}
    >
      {/* Header */}
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          pb: 1,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Choose How to Send Email
        </Typography>
        <IconButton onClick={handleClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <Divider />

      {/* Content */}
      <DialogContent sx={{ mt: 1 }}>
        <Typography variant="body2" sx={{ mb: 2 }}>
          It seems your system doesn’t have a default mail app configured.
          <br />
          You can use one of the following webmail options:
        </Typography>

        <List>
          {emailOptions.map((option) => (
            <ListItem key={option.name} disablePadding>
              <ListItemButton
                onClick={() => handleOpenMail(option)}
                sx={{
                  borderRadius: 2,
                  mb: 1,
                  "&:hover": {
                    backgroundColor: `${option.color}10`,
                  },
                }}
              >
                <ListItemIcon>{option.icon}</ListItemIcon>
                <ListItemText
                  primary={
                    <Typography sx={{ color: option.color, fontWeight: 500 }}>
                      {option.name}
                    </Typography>
                  }
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>

        {/* Manual copy */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            bgcolor: "#f7f7f7",
            borderRadius: 2,
            px: 2,
            py: 1,
            mt: 2,
          }}
        >
          <Typography variant="body2">
            Copy email: <strong>{emailData}</strong>
          </Typography>
          <IconButton onClick={handleCopy} size="small" title="Copy email">
            <ContentCopyIcon fontSize="small" />
          </IconButton>
        </Box>
      </DialogContent>

      {/* Footer buttons */}
      <DialogActions sx={{ pt: 0 }}>
        <Button variant="outlined" onClick={handleClose}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MailFallbackModal;
